import React from "react";
import { Alert } from "antd";
const CantDispatchAlert = ({ style = {} }) => (React.createElement(Alert, { message: "You are unable to self-dispatch currently - Please contact Autosled for assistance", type: "info", style: style, showIcon: true }));
export default CantDispatchAlert;
